import React from 'react';
import { AssignCarrierAccountViewStore } from 'modules/order/stores';
import { AssignCarrierAccountTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView((rootStore, componentProps) => new AssignCarrierAccountViewStore(rootStore, componentProps), 'assignCarrierAccountViewStore')
class AssignCarrierAccount extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <AssignCarrierAccountTemplate {...this.props} />;
	}
}

export default AssignCarrierAccount;